import { CheckboxWithOptionsValue } from '@/components/filter-panel/filter-panel.types';

export interface EventData {
  comment: string;
  date: string;
  impact: string;
  internal: boolean;
  name: string;
  type: string;
  uuid: string;
  webPage: string;
}

export interface EventsParams {
  'sortBy[0].field': string;
  'sortBy[0].direction': string;
  'dateRange.min': string;
  'dateRange.max': string;
  sortByField: string;
  sortByDirection: string;
  dateRange?: string[];
  impacts: string[];
  internal: boolean | null;
  name: string;
  page: number;
  size: number;
  types: string[];
}

export interface EventsFilters {
  name: string;
  dateRange: string[];
  types: string[];
  impacts: string[];
  internal: null | boolean;
}

export interface CheckboxObject {
  uuid?: string;
  name: string;
  label: string;
  contentType: string;
  values: Partial<CheckboxWithOptionsValue>[];
}

export enum EventTypes {
  HOLIDAY = 'HOLIDAY',
  FESTIVAL = 'FESTIVAL',
  CONFERENCE = 'CONFERENCE',
  FAIR = 'FAIR',
  CONCERT = 'CONCERT',
  CONGRESS = 'CONGRESS',
  SPORT = 'SPORT',
  OTHER = 'OTHER'
}

export enum EventColumns {
  DATE = 'date',
  TYPE = 'type',
  NAME = 'name',
  IMPACT = 'impact',
  INTERNAL = 'internal',
  WEB_PAGE = 'webPage',
  COMMENT = 'comment',
  ACTIONS = 'actions'
}
